import { FilterableList } from "../filterable-list";
import { FilterParameter, SearchResults } from "../models/types"
import { Helpers } from "../helpers/helpers"
import { ResourceList, ResourceViewModel } from "../pages/resource-list"
export class ProductList extends FilterableList<ProductViewModel>
{

	resultsWrapper: HTMLElement;
	filterWrapper: HTMLElement;
	cardCtaCloned: HTMLElement;

	public constructor() {
		super('.product-list .cards');
		const cardCta = document.querySelector('.product-list .cards .card-cta');
		if (cardCta) {
			this.cardCtaCloned = document.querySelector('.product-list .cards .card-cta').cloneNode(true) as HTMLElement;
		}
	}

	createResult(dataItem: ProductViewModel): void {
		const template = document.querySelector('.product-template .card').cloneNode(true) as HTMLElement;
		const image = template.querySelector('.image');
		const title = template.querySelector('h3');
		const url = template.querySelector('a') as HTMLAnchorElement;
		const content = template.querySelector('.content');
		if (dataItem.thumbnailImage) {
			const img = document.createElement("img") as HTMLImageElement;
			img.alt = dataItem.title;
			img.src = dataItem.thumbnailImage.replace("~", "");
			image.append(img);
			image.querySelector('.no-image').remove();
		}

		title.innerHTML = dataItem.title;		
		content.innerHTML += dataItem.summary;
		url.href = dataItem.url.replace("~", "");

		this.resultsWrapper.append(template);
	}

	clearResults(): void {
		if (this.resultsWrapper) {
			this.resultsWrapper.innerHTML = "";
		}
	}

	onQueryChange(selectedFilters: FilterParameter[]): void {
		if (selectedFilters.length > 0) {
			document.querySelector('.section-expandable.expanded')?.classList.remove('expanded');
		}

		this.search("/products/search", selectedFilters, false, () => {
			if (selectedFilters.length <= 0) {
				const cardToInsertBefore = this.resultsWrapper.querySelector('.card:nth-child(7)');
				if (cardToInsertBefore && this.cardCtaCloned) {
					this.resultsWrapper.insertBefore(this.cardCtaCloned, cardToInsertBefore);

				}
			}
		});


		//update supplemental widgets 
		let resourceWidget = document.querySelector('.resource-widget') as HTMLElement;
		let viewAllButton = resourceWidget?.querySelector('.view-all') as HTMLAnchorElement;
		if (resourceWidget) {
			this.searchResources(selectedFilters, resourceWidget.querySelector('.card-list'));
			if (viewAllButton) {
				let params = Helpers.getUrlParameters();
				let resourceViewAllLink = "/resources";
				if (params) {
					resourceViewAllLink += "?filters=" + params['filters'];
				}
				viewAllButton.href = resourceViewAllLink;
			}
		}

	}

	toggleLoader(isLoading: boolean): void {
		const loader = document.querySelector('.product-list .loader');

		if (isLoading) {
			loader.classList.remove('d-none');
		} else {
			loader.classList.add('d-none');
		}
	}

	searchResources(selectedFilters: FilterParameter[], resultList: HTMLElement, maxCount = 0) {
		let self = this;
		let request = new XMLHttpRequest();

		request.open("POST", "/resources/search", true);
		request.setRequestHeader("Content-Type", "application/json");

		request.onload = function (e) {

			if (this.status >= 200 && this.status < 400) {
				const searchResults = JSON.parse(this.response) as SearchResults<ResourceViewModel>;
				if (searchResults.results.length === 0) {

					//hide widget
				} else {
					resultList.innerHTML = '';
					searchResults.results.slice(0, 3).forEach(result => {
						let card = ResourceList.createResourceCard(result);
						resultList.append(card);
					});
				}
			} else {
				console.error("search() failed", this);
			}

		}

		request.onerror = function () {
			console.error("search() error", this);

		}

		let searchRequest = {
			pageIndex: 1,
			filters: selectedFilters
		};

		request.send(JSON.stringify(searchRequest));
	}


}

export interface ProductViewModel {
	thumbnailImage: string;
	title: string;
	summary: string;
	url: string;
}